import { render, staticRenderFns } from "./submitDemand.vue?vue&type=template&id=a78330de&scoped=true"
import script from "./submitDemand.vue?vue&type=script&lang=js"
export * from "./submitDemand.vue?vue&type=script&lang=js"
import style0 from "./submitDemand.vue?vue&type=style&index=0&id=a78330de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78330de",
  null
  
)

export default component.exports